import { render, staticRenderFns } from "./payForFriend.vue?vue&type=template&id=53cf9070&scoped=true&"
import script from "./payForFriend.vue?vue&type=script&lang=js&"
export * from "./payForFriend.vue?vue&type=script&lang=js&"
import style0 from "./payForFriend.vue?vue&type=style&index=0&id=53cf9070&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cf9070",
  null
  
)

export default component.exports